var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-calendar',{scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var data = ref.data;
return [_c('p',{class:data.isSelected ? 'is-selected' : ''},[_vm._v(" "+_vm._s(data.day.split('-').slice(1).join('-'))+" "+_vm._s(data.isSelected ? '✔️' : '')+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }